import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCiegDocuments, normalizeCiegDocument } from '../../../services/ciegDocumentsService';

const CiegDocumentListPage = ({ title, categoryPath }) => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const styleEnabled = { background: '#990B0C', color: '#FFFFFF', fontSize: '14', fontWeight: 'bold', cursor: 'pointer' };
    const styleLocalidad = { background: ' #dfd253 ', color: '#FFFFFF', fontSize: '11', fontWeight: 'bold', cursor: 'pointer' };

    useEffect(() => {
        let mounted = true;

        setLoading(true);
        getCiegDocuments(categoryPath)
            .then((data) => {
                if (mounted) {
                    setDocuments(data.map(normalizeCiegDocument));
                }
            })
            .catch((error) => {
                console.log(error);
                if (mounted) {
                    setDocuments([]);
                }
            })
            .finally(() => {
                if (mounted) {
                    setLoading(false);
                }
            });

        return () => {
            mounted = false;
        };
    }, [categoryPath]);

    return (
        <div className='container'>
            <br />
            <div className='row'>
                <div className='col-lg-12 text-center'>
                    <h2>{title}</h2>
                </div>
            </div>
            <hr />
            {loading &&
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <p>Cargando...</p>
                    </div>
                </div>
            }
            {!loading && documents.length === 0 &&
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <p>No hay archivos disponibles.</p>
                    </div>
                </div>
            }
            {documents.map((document) => {
                const isChild = document.metadata.item_level === 'localidad';
                const textColor = isChild ? '#b8b8b8' : '#000000';
                const TitleTag = isChild ? 'h5' : 'h3';

                return (
                    <React.Fragment key={document.id || document.file}>
                        <div className='row'>
                            <div className='col-md-11'>
                                <TitleTag>
                                    <Link to={`/pdf/${document.file}`} data-tip data-for={document.file} style={{ color: textColor, textDecoration: 'none' }}>
                                        {document.title}
                                    </Link>
                                </TitleTag>
                            </div>
                            <div className='col-md-1'>
                                <div className='col-md-6'></div>
                                <div className='col-md-6 text-center' style={isChild ? styleLocalidad : styleEnabled}>
                                    <Link to={`/pdf/${document.file}`} data-tip data-for={document.file} style={{ color: '#FFF', textDecoration: 'none' }}>
                                        <span><small>{document.type}</small></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default CiegDocumentListPage;
